export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  status: '连载中' | '已完结';
  rating: number;
  views: string;
  description: string;
  latestChapter: string;
  chapterCount: number;
  tags: string[];
  updatedAt: string;
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { name: '全部', slug: 'all', icon: 'ri-apps-line', count: 120 },
  { name: '恋爱', slug: 'romance', icon: 'ri-heart-line', count: 35 },
  { name: '动作', slug: 'action', icon: 'ri-fire-line', count: 28 },
  { name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line', count: 22 },
  { name: '悬疑', slug: 'thriller', icon: 'ri-search-eye-line', count: 15 },
  { name: '喜剧', slug: 'comedy', icon: 'ri-emotion-laugh-line', count: 12 },
  { name: '剧情', slug: 'drama', icon: 'ri-film-line', count: 8 },
];

export const comics: Comic[] = [
  {
    id: 'secret-romance',
    title: '秘密恋爱手册',
    author: '李智恩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20comic%20cover%2C%20two%20young%20people%20in%20love%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20warm%20tones%2C%20beautiful%20manhwa%20art%20style%2C%20clean%20illustration%20with%20gentle%20lighting%2C%20simple%20background%20with%20spring%20atmosphere%2C%20emotional%20and%20romantic%20mood&width=600&height=800&seq=manhwa-cover-01&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    status: '连载中',
    rating: 4.8,
    views: '128.5万',
    description: '在首尔繁华的都市中，两个完全不同世界的人意外相遇。一个是安静内向的插画师，一个是阳光开朗的咖啡店老板。一次偶然的邂逅，让两颗心开始悄然靠近。但他们各自的过去和秘密，是否会让这段感情变得扑朔迷离？',
    latestChapter: '第87话',
    chapterCount: 87,
    tags: ['恋爱', '都市', '治愈', '日常'],
    updatedAt: '2026-07-08',
  },
  {
    id: 'blade-of-destiny',
    title: '命运之刃',
    author: '朴俊秀',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20comic%20cover%2C%20warrior%20with%20sword%20in%20epic%20battle%20pose%2C%20dramatic%20lighting%20with%20red%20and%20dark%20tones%2C%20manhwa%20art%20style%2C%20dynamic%20composition%2C%20simple%20dark%20background%20with%20energy%20effects%2C%20intense%20and%20powerful%20atmosphere&width=600&height=800&seq=manhwa-cover-02&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    status: '连载中',
    rating: 4.9,
    views: '256.3万',
    description: '在一个被黑暗势力笼罩的世界里，年轻的剑客金泰浩继承了传说中的命运之刃。他必须踏上艰难的修炼之路，与各路强者对决，揭开隐藏在命运背后的惊天秘密。',
    latestChapter: '第156话',
    chapterCount: 156,
    tags: ['动作', '热血', '奇幻', '冒险'],
    updatedAt: '2026-07-07',
  },
  {
    id: 'magic-academy',
    title: '魔法学院秘闻录',
    author: '崔贤宇',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20comic%20cover%2C%20magical%20academy%20student%20casting%20spells%2C%20mystical%20blue%20and%20purple%20magical%20effects%2C%20manhwa%20art%20style%2C%20whimsical%20and%20enchanting%2C%20simple%20starry%20night%20background%2C%20mysterious%20and%20magical%20vibe&width=600&height=800&seq=manhwa-cover-03&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    status: '已完结',
    rating: 4.7,
    views: '189.2万',
    description: '出身平凡的女孩韩素希意外收到魔法学院的录取通知书。在这个充满魔法与奇迹的世界里，她发现了自己隐藏的魔法天赋，也揭开了一个关于学院百年秘闻的惊人之谜。',
    latestChapter: '第200话（完结）',
    chapterCount: 200,
    tags: ['奇幻', '校园', '魔法', '冒险'],
    updatedAt: '2026-06-30',
  },
  {
    id: 'shadow-detective',
    title: '暗影侦探',
    author: '郑宇成',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20comic%20cover%2C%20detective%20in%20trench%20coat%20in%20dark%20alley%2C%20noir%20style%20with%20sharp%20shadows%2C%20manhwa%20art%20style%2C%20mysterious%20and%20suspenseful%2C%20simple%20urban%20night%20background%20with%20street%20lamps%2C%20tense%20and%20gripping%20atmosphere&width=600&height=800&seq=manhwa-cover-04&orientation=portrait',
    category: '悬疑',
    categorySlug: 'thriller',
    status: '连载中',
    rating: 4.6,
    views: '98.7万',
    description: '前刑警姜成浩转行成为私家侦探，接手了一桩看似普通的失踪案。随着调查深入，他发现自己被卷入了一场涉及政商名流的巨大阴谋。每一个线索都指向一个更加黑暗的真相。',
    latestChapter: '第63话',
    chapterCount: 63,
    tags: ['悬疑', '推理', '犯罪', '都市'],
    updatedAt: '2026-07-06',
  },
  {
    id: 'office-comedy',
    title: '职场爆笑日常',
    author: '金美英',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20comic%20cover%2C%20funny%20office%20workers%20in%20hilarious%20situations%2C%20bright%20and%20colorful%20illustration%2C%20manhwa%20art%20style%2C%20humorous%20and%20lighthearted%2C%20simple%20office%20background%2C%20cheerful%20and%20playful%20mood&width=600&height=800&seq=manhwa-cover-05&orientation=portrait',
    category: '喜剧',
    categorySlug: 'comedy',
    status: '连载中',
    rating: 4.5,
    views: '156.1万',
    description: '新入职场的菜鸟朴智旻每天都面临着各种啼笑皆非的职场挑战。从奇葩同事到离谱老板，从加班地狱到团建噩梦，每一次经历都让人捧腹大笑又感同身受。',
    latestChapter: '第112话',
    chapterCount: 112,
    tags: ['喜剧', '职场', '日常', '搞笑'],
    updatedAt: '2026-07-08',
  },
  {
    id: 'tears-of-seoul',
    title: '首尔之泪',
    author: '尹恩惠',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20comic%20cover%2C%20emotional%20woman%20looking%20at%20city%20skyline%20at%20sunset%2C%20melancholic%20warm%20tones%2C%20manhwa%20art%20style%2C%20deeply%20emotional%20and%20touching%2C%20simple%20cityscape%20background%2C%20bittersweet%20and%20moving%20atmosphere&width=600&height=800&seq=manhwa-cover-06&orientation=portrait',
    category: '剧情',
    categorySlug: 'drama',
    status: '已完结',
    rating: 4.9,
    views: '312.4万',
    description: '讲述了三个不同年龄段的女性在首尔这座城市中，面对爱情、家庭和事业的挣扎与成长。她们的故事交织在一起，构成了一幅关于现代都市女性生存状态的动人画卷。',
    latestChapter: '第180话（完结）',
    chapterCount: 180,
    tags: ['剧情', '都市', '女性', '人生'],
    updatedAt: '2026-05-15',
  },
  {
    id: 'love-in-darkness',
    title: '暗夜恋歌',
    author: '朴智妍',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20dark%20romance%20comic%20cover%2C%20couple%20embracing%20under%20moonlight%2C%20mysterious%20dark%20purple%20and%20silver%20tones%2C%20manhwa%20art%20style%2C%20romantic%20yet%20mysterious%2C%20simple%20moonlit%20night%20background%2C%20passionate%20and%20enigmatic%20vibe&width=600&height=800&seq=manhwa-cover-07&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    status: '连载中',
    rating: 4.7,
    views: '201.8万',
    description: '她是一个只能在夜晚出现的灵魂，他是一个只能在夜晚看见她的少年。一场超越生死的爱情故事，在月光下悄然展开。当黎明来临，他们的爱情是否能跨越界限？',
    latestChapter: '第95话',
    chapterCount: 95,
    tags: ['恋爱', '奇幻', '治愈', '唯美'],
    updatedAt: '2026-07-07',
  },
  {
    id: 'dragon-warrior',
    title: '龙战士传奇',
    author: '金泰亨',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20fantasy%20comic%20cover%2C%20dragon%20warrior%20with%20fiery%20aura%20fighting%2C%20epic%20red%20and%20gold%20tones%2C%20manhwa%20art%20style%2C%20grand%20and%20heroic%2C%20simple%20volcanic%20background%2C%20fierce%20and%20majestic%20atmosphere&width=600&height=800&seq=manhwa-cover-08&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    status: '连载中',
    rating: 4.8,
    views: '278.9万',
    description: '龙族末裔李浩宇在人类世界隐藏身份生活，直到邪恶势力入侵，他必须觉醒体内的龙之力。与伙伴们一起，他踏上了拯救两个世界的史诗旅程。',
    latestChapter: '第203话',
    chapterCount: 203,
    tags: ['动作', '奇幻', '热血', '龙'],
    updatedAt: '2026-07-08',
  },
  {
    id: 'witchs-garden',
    title: '魔女的花园',
    author: '韩素英',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20comic%20cover%2C%20beautiful%20witch%20in%20enchanted%20garden%20with%20glowing%20flowers%2C%20soft%20green%20and%20golden%20magical%20light%2C%20manhwa%20art%20style%2C%20ethereal%20and%20dreamy%2C%20simple%20garden%20background%2C%20peaceful%20and%20magical%20atmosphere&width=600&height=800&seq=manhwa-cover-09&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    status: '连载中',
    rating: 4.6,
    views: '134.5万',
    description: '继承了外婆留下的神秘花园后，普通大学生林秀雅发现自己拥有了操控植物的魔法能力。而这个花园里隐藏的秘密，远比她想象的更加深远和危险。',
    latestChapter: '第78话',
    chapterCount: 78,
    tags: ['奇幻', '魔法', '治愈', '冒险'],
    updatedAt: '2026-07-05',
  },
  {
    id: 'mystery-apartment',
    title: '诡异公寓',
    author: '申东赫',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20thriller%20comic%20cover%2C%20creepy%20apartment%20building%20at%20night%20with%20mysterious%20shadows%2C%20dark%20and%20eerie%20tones%2C%20manhwa%20art%20style%2C%20chilling%20and%20suspenseful%2C%20simple%20dark%20urban%20background%2C%20scary%20and%20unnerving%20vibe&width=600&height=800&seq=manhwa-cover-10&orientation=portrait',
    category: '悬疑',
    categorySlug: 'thriller',
    status: '已完结',
    rating: 4.4,
    views: '87.3万',
    description: '搬进廉价公寓的新租户们接连遭遇诡异事件。深夜的脚步声、墙上的神秘涂鸦、消失的邻居……这栋公寓里究竟隐藏着什么可怕秘密？',
    latestChapter: '第50话（完结）',
    chapterCount: 50,
    tags: ['悬疑', '恐怖', '都市', '推理'],
    updatedAt: '2026-04-20',
  },
  {
    id: 'neighborhood-king',
    title: '小区王',
    author: '赵权',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20slice%20of%20life%20comic%20cover%2C%20funny%20neighborhood%20characters%20hanging%20out%2C%20bright%20and%20vibrant%20colors%2C%20manhwa%20art%20style%2C%20warm%20and%20humorous%2C%20simple%20neighborhood%20street%20background%2C%20friendly%20and%20entertaining%20mood&width=600&height=800&seq=manhwa-cover-11&orientation=portrait',
    category: '喜剧',
    categorySlug: 'comedy',
    status: '连载中',
    rating: 4.5,
    views: '112.6万',
    description: '一个平凡小区的居民们，每个人都有着自己独特的个性和故事。从大妈们的菜市场风云到小孩们的街头争霸，每一天都是精彩纷呈的日常喜剧。',
    latestChapter: '第145话',
    chapterCount: 145,
    tags: ['喜剧', '日常', '生活', '搞笑'],
    updatedAt: '2026-07-08',
  },
  {
    id: 'winter-letter',
    title: '冬日来信',
    author: '姜娜拉',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20romance%20comic%20cover%2C%20person%20reading%20letter%20by%20window%20in%20winter%20snow%2C%20soft%20white%20and%20blue%20winter%20tones%2C%20manhwa%20art%20style%2C%20nostalgic%20and%20heartwarming%2C%20simple%20snowy%20window%20background%2C%20tender%20and%20emotional%20atmosphere&width=600&height=800&seq=manhwa-cover-12&orientation=portrait',
    category: '剧情',
    categorySlug: 'drama',
    status: '已完结',
    rating: 4.9,
    views: '167.2万',
    description: '一个冬天，一封来自十年前的来信打破了平静生活。收信人踏上了寻找寄信人的旅程，沿途遇见了许多温暖的人和故事。这是一部关于回忆、遗憾与和解的暖心之作。',
    latestChapter: '第120话（完结）',
    chapterCount: 120,
    tags: ['剧情', '治愈', '人生', '温情'],
    updatedAt: '2026-03-10',
  },
  {
    id: 'campus-blossom',
    title: '校园花语',
    author: '李秀贤',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20romance%20comic%20cover%2C%20students%20in%20school%20uniform%20under%20blooming%20trees%2C%20soft%20pastel%20pink%20and%20green%20tones%2C%20manhwa%20art%20style%2C%20youthful%20and%20sweet%2C%20simple%20school%20campus%20background%2C%20fresh%20and%20innocent%20vibe&width=600&height=800&seq=manhwa-cover-13&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    status: '连载中',
    rating: 4.6,
    views: '145.7万',
    description: '高中校园里，四个性格迥异的少年少女在青春最美好的年华相遇。友情与爱情的界限模糊，成长与迷茫交织，这是一部属于青春的花样年华。',
    latestChapter: '第68话',
    chapterCount: 68,
    tags: ['恋爱', '校园', '青春', '成长'],
    updatedAt: '2026-07-06',
  },
  {
    id: 'celestial-war',
    title: '天界战争',
    author: '吴世勋',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20fantasy%20comic%20cover%2C%20celestial%20warriors%20in%20epic%20battle%20with%20wings%2C%20golden%20and%20white%20divine%20light%2C%20manhwa%20art%20style%2C%20majestic%20and%20grand%2C%20simple%20heavenly%20sky%20background%2C%20glorious%20and%20epic%20atmosphere&width=600&height=800&seq=manhwa-cover-14&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    status: '连载中',
    rating: 4.7,
    views: '223.4万',
    description: '天界与魔界之间持续千年的战争即将迎来最终决战。人类少年郑云意外被选中成为天界战士，他必须在短时间内掌握神力，肩负起拯救三界的使命。',
    latestChapter: '第178话',
    chapterCount: 178,
    tags: ['动作', '奇幻', '神魔', '史诗'],
    updatedAt: '2026-07-07',
  },
  {
    id: 'dessert-shop',
    title: '甜蜜烘焙坊',
    author: '白智媛',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20slice%20of%20life%20comic%20cover%2C%20cute%20dessert%20shop%20with%20colorful%20pastries%2C%20warm%20and%20sweet%20pastel%20colors%2C%20manhwa%20art%20style%2C%20cozy%20and%20delightful%2C%20simple%20bakery%20interior%20background%2C%20charming%20and%20appetizing%20mood&width=600&height=800&seq=manhwa-cover-15&orientation=portrait',
    category: '喜剧',
    categorySlug: 'comedy',
    status: '连载中',
    rating: 4.4,
    views: '76.8万',
    description: '甜点师金多美开了一家小小的烘焙坊，却因为各种奇葩顾客和意外事件闹出了无数笑话。每一块蛋糕背后，都有一个温暖又爆笑的故事。',
    latestChapter: '第56话',
    chapterCount: 56,
    tags: ['喜剧', '美食', '治愈', '日常'],
    updatedAt: '2026-07-05',
  },
  {
    id: 'last-constellation',
    title: '最后的星座',
    author: '金南俊',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20fantasy%20comic%20cover%2C%20mysterious%20constellation%20in%20night%20sky%20with%20silhouette%20below%2C%20deep%20indigo%20and%20silver%20star%20tones%2C%20manhwa%20art%20style%2C%20philosophical%20and%20profound%2C%20simple%20starry%20night%20background%2C%20contemplative%20and%20mysterious%20atmosphere&width=600&height=800&seq=manhwa-cover-16&orientation=portrait',
    category: '剧情',
    categorySlug: 'drama',
    status: '连载中',
    rating: 4.8,
    views: '91.3万',
    description: '天文学家崔珉豪发现了一颗即将消失的星星，而它与一个古老的预言紧密相连。在现代科学与古老传说的交织中，他踏上了一段跨越时空的探索之旅。',
    latestChapter: '第42话',
    chapterCount: 42,
    tags: ['剧情', '科幻', '哲理', '探索'],
    updatedAt: '2026-07-08',
  },
];

export const featuredComicIds = ['secret-romance', 'blade-of-destiny', 'tears-of-seoul', 'dragon-warrior', 'winter-letter'];
export const hotComicIds = ['blade-of-destiny', 'dragon-warrior', 'tears-of-seoul', 'love-in-darkness', 'celestial-war', 'secret-romance', 'magic-academy', 'shadow-detective'];
export const newUpdateIds = ['office-comedy', 'neighborhood-king', 'last-constellation', 'secret-romance', 'dragon-warrior', 'celestial-war', 'witchs-garden', 'campus-blossom'];